import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	repeatEscalation: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.repeat-escalation.no-translate',
		defaultMessage: 'Repeat the escalation',
		description: 'Title of section separator',
	},
	repeatEscalationDescription: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.repeat-escalation-description.no-translate',
		defaultMessage:
			"If alerts aren't acknowledged, turning this on will repeat escalations after a specified duration for a specified number of times. You can also set it to automatically close the alerts when the escalation repetitions are completed.",
		description: 'Description of repeat escalation section',
	},
	repeat: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.repeat.no-translate',
		defaultMessage: 'Repeat',
		description: 'Label of repeat input',
	},
	actions: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.actions.no-translate',
		defaultMessage: 'Actions',
		description: 'Label of actions',
	},
	ifAlertIsNotClosed: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.if-alert-is-not-closed.no-translate',
		defaultMessage:
			'Change the alert status to open (even if acknowledged or seen already) on every repeat',
		description: 'Label of actions first checkbox',
	},
	ifEscalationRepeats: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.if-escalation-repeats.no-translate',
		defaultMessage: 'Close the alert automatically when the repeats are over',
		description: 'Label of actions second checkbox',
	},
	repeatEscalationInput: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.repeat-escalation-input.no-translate',
		defaultMessage:
			'<input></input> minute(s) after processing the last escalation rule <select></select> times',
		description:
			'Full line of repeat escalation input. example: <input> minute(s) after processing the last escalation rule <select> times',
	},
	repeatMaxLimit: {
		id: 'eoc.escalation-policies.common.ui.repeat-max-limit.no-translate',
		defaultMessage: `Repeat time cannot be greater than 1440 minutes.`,
		description: 'Error message of time limit that shown if time is bigger than 1440 minutes',
	},
	repeatMinLimit: {
		id: 'eoc.escalation-policies.common.ui.repeat-min-limit.no-translate',
		defaultMessage: `Repeat time cannot be negative number.`,
		description: 'Error message of time limit that shown if time is lesser than 0 minute',
	},
	fieldRequired: {
		id: 'eoc.escalation-policies.common.ui.field-required.no-translate',
		defaultMessage: `This field is required.`,
		description: 'Error message of inputs that shown when there is no value',
	},
});

export default messages;
